<div class="tipps {{layout}}">
  <h2 class="text-center">{{headline | translate}}</h2>
  <ol>
    @for (tipp of tipps | slice:0:tippCount; track tipp) {
      <li [class.nohover]="layout === 'single'" (click)="showOverlay(tipp['name'])">
        <div class="grid-x" [class.grid-margin-x]="layout === 'list'">
          @if (layout !== 'list' && imagePath) {
            <div class="cell small-12 text-center relative no-print" [class.medium-3]="layout !== 'single'" [class.large-5]="layout === 'single'">
              <img [src]="imagePath + tipp['name'] + '.jpg'" alt="">
              <span class="copyright">{{textkeyBase + tipp['name'] + '.copyright' | translate}}</span>
            </div>
          }
          <div class="cell small-12" [class.large-8]="layout === 'list'" [class.medium-9]="layout === 'smalllist'" [class.large-5]="layout === 'smalllist'" [class.large-7]="layout === 'single'">
            @if (layout !== 'single') {
              <h3>{{textkeyBase + tipp["name"] | translate}}</h3>
            }
            @if (layout !== 'list') {
              <div [innerHTML]="textkeyBase + tipp['name'] + '.teaser' | translate | safeHtml"></div>
            }
            <div class="show-print-only text" [innerHTML]="textkeyBase + tipp['name'] + '.text' | translate | safeHtml"></div>
            <div class="show-print-only text" [innerHTML]="textkeyBase + tipp['name'] + '.description' | translate: (tipp.hasOwnProperty('placeholder')? tipp['placeholder'] : []) | safeHtml"></div>
            <div class="show-print-only text">{{textkeyBase + '.more' | translate}} <a [href]="textkeyBase + tipp['name'] + '.link' | translate" [innerHTML]="textkeyBase + tipp['name'] + '.link' | translate | safeHtml"></a></div>
            @if (tipp['hasCo2Marker'] === true) {
              <span class="climatebadge no-print" [innerHTML]="textkeyBase + 'climatebadge' | translate"></span>
            }
            @if (layout === 'single') {
              <button class="button primary right no-print">
                <span [innerHTML]="textkeyBase + tipp['name'] + '.cta' | translate"></span>
              </button>
            }
          </div>
          @if (layout !== 'single') {
            <div class="cell small-12 large-4 no-print">
              @if (tipp['fast'] === true) {
                <span class="timebadge" [innerHTML]="textkeyBase + 'timebadge' | translate"></span>
              }
              <button class="button primary right" [class.center]="tipp['saving'] === 0" >
                <div class="span">
                  @if (tipp['saving'] > 0) {
                    <i class="icon-pig"></i>
                  }
                  @if (tipp['saving'] > 0) {
                    <i class="icon-pig" [class.transparent]="tipp['saving'] < 35"></i>
                  }
                  @if (tipp['saving'] > 0) {
                    <i class="icon-pig" [class.transparent]="tipp['saving'] < 80"></i>
                  }
                </div>
                <span [innerHTML]="textkeyBase + tipp['name'] + '.cta' | translate: {fallback: textkeyBase + 'cta', saving: tipp['saving']}"></span>
              </button>
            </div>
          }
        </div>
      </li>
    }
    @if (layout === 'list' && tipps.length > tippCountDefault) {
      <li class="more no-print">
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-text-right">
            @if (tipps.length > tippCount) {
              <button class="button primary right" (click)="tippCount = tipps.length">
                <span [innerHTML]="textkeyBase + 'all' | translate: {count: tipps.length}"></span>
              </button>
            }
            @if (tipps.length === tippCount && tipps.length > tippCountDefault) {
              <a (click)="tippCount = tippCountDefault">{{textkeyBase + 'less' | translate}}<i
              class="icon-chevron-up"></i></a>
            }
          </div>
        </div>
      </li>
    }
  </ol>
</div>
